const Base64 = require("js-base64").Base64;
/* 公共方法 */

// 时间格式 this.$commonJs.timeFormat(item.navdate, 'yyyy-mm-dd')
function timeFormat (value, format) {
    let date = new Date(value);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let h = date.getHours();
    let min = date.getMinutes();
    let s = date.getSeconds();
    let result = "";
    switch (format) {
        case 'yyyy':
            result = `${y}`;
            break;
        case 'yyyy-mm':
            result = `${y}-${m < 10 ? "0" + m : m}`;
            break;
        case 'yyyy-mm-dd':
            result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
            break;
        case 'mm-dd':
            result = `${m < 10 ? "0" + m : m}:${d < 10 ? "0" + d : d}`;
            break;
        case 'hh:mm':
            result = `${h < 10 ? "0" + h : h}:${min < 10 ? "0" + min : min}`;
            break;
        case 'hh:mm:ss':
            result = `${h < 10 ? "0" + h : h}:${min < 10 ? "0" + min : min}:${s < 10 ? "0" + s : s}`;
            break;
        default:
            result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} ${h < 10 ? "0" + h : h
                }:${min < 10 ? "0" + min : min}:${s < 10 ? "0" + s : s}`;
    }
    return result;
}


//申请时间格式  20210324 → 2021/03/24
function getDateStrTh (date) {
    if ((!date) || (date.trim().length != 8)) {
        return "--";
    }
    return date.substr(0, 4) + "/" + date.substr(4, 2) + "/" +
        date.substr(6, 2) + "";
}
//申请时间格式  20210324 → 2021-03-24
function getDateStrHg (date) {
    if ((!date) || (date.trim().length != 8)) {
        return "--";
    }
    return date.substr(0, 4) + "-" + date.substr(4, 2) + "-" +
        date.substr(6, 2) + "";
}
//申请时间格式  20210324 → 2021年03月24日
function getDateStrHz (date) {
    if ((!date) || (date.trim().length != 8)) {
        return "--";
    }
    return date.substr(0, 4) + "年" + date.substr(4, 2) + "月" +
        date.substr(6, 2) + "日";
}
// 当前时间    20210325
function getCurrentDate () {
    var d = new Date();
    var d1 = d.getFullYear();
    var d2 = d.getMonth() + 1;
    d2 = d2 < 10 ? '0' + d2 : "" + d2;
    var d3 = d.getDate();
    d3 = d3 < 10 ? '0' + d3 : "" + d3;
    return d1 + d2 + d3;
}


//数字格式化，三位一逗
function amountFormat (str, key) {
    var i = str.length;
    var j = (str.indexOf(".") > 0) ? str.indexOf(".") : i;
    if (j < key) {
        return str;
    } else {

        var array = new Array();
        for (var k = j - key; k >= 0; k -= key) {
            array.unshift(str.substring(k, i));
            i = k;
        }
        if ((j % key) != 0) {
            array.unshift(str.substring(k, i));
        }
        var string = array.join(",");
        return string;
    }
}

//比较时间 '2015-10-10 00:00:00'或'2015-10-10'格式
function tab (date1, date2) {
    var oDate1 = new Date(date1);
    var oDate2 = new Date(date2);
    if (oDate1.getTime() > oDate2.getTime()) {
        return '1' //console.log('第一个大');
    } else if (oDate1.getTime() < oDate2.getTime()) {
        return '2' //console.log('第二个大');
    } else if (oDate1.getTime() == oDate2.getTime()) {
        return '3' //console.log('一样大');
    }
}

//两个日期的差值(d1 - today).
function DateDiff (enddate) {
    var day = 24 * 60 * 60 * 1000;
    var d1 = enddate.substr(0, 10);
    var dateArr = d1.split("-");
    var checkDate = new Date();
    checkDate.setFullYear(dateArr[0], dateArr[1] - 1, dateArr[2]);
    var checkTime = checkDate.getTime();
    var today = new Date();
    var checkTime2 = today.getTime();
    var cha = (checkTime - checkTime2) / day;
    return cha;
}

//交易时间点击事件
//1。获取当前日期 (0,'d7','/')当前时间 (7,'d7','/')一周  (0,1,'/') type:'d7',1,3,6,12
function getBeforeDate (n, type, str) {
    var s = ''
    if (type == 'd7') {
        var n = n;
        var d = new Date();
        var year = d.getFullYear();
        var mon = d.getMonth() + 1;
        var day = d.getDate();
        if (day <= n) {
            if (mon > 1) {
                mon = mon - 1;
            } else {
                year = year - 1;
                mon = 12;
            }
        }
        d.setDate(d.getDate() - n);
        year = d.getFullYear();
        mon = d.getMonth() + 1;
        day = d.getDate();
        s = year + str + (mon < 10 ? ('0' + mon) : mon) + str + (day < 10 ? ('0' + day) : day);
        return s;
    } else {
        var n = n;
        var d = new Date();
        var year = d.getFullYear();
        var mon = d.getMonth() + 1;
        var day = d.getDate();
        if (day <= n) {
            if (mon > 1) {
                mon = mon - 1;
            } else {
                year = year - 1;
                mon = 12;
            }
        }
        d.setDate(d.getDate() - n);
        year = d.getFullYear();
        mon = d.getMonth() + 1;
        day = d.getDate();
        if (type == 1) {
            mon = mon - 1;
        } else if (type == 3 || type == 6) {
            mon = mon - type;
            if (mon <= 0) {
                year = year - 1;
                mon = 12 + mon;
            }
        } else if (type == 12) {
            year = year - 1;
        } else if (type == 36) {
            year = year - 3;
        }
        s = year + str + (mon < 10 ? ('0' + mon) : mon) + str + (day < 10 ? ('0' + day) : day);
        return s;
    }

}

//银行卡筛选
function getInfobyChannelId (channelid) {
    if (channelid == "7101") {
        return "banklogo1.png,工商银行储蓄卡,10,40,富友-工行"; //单笔限额，单日限额
    } else if (channelid == "7102") {
        return "banklogo2.png,农业银行储蓄卡,5,20,富友-农行"; //单笔限额，单日限额
    } else if (channelid == "7103") {
        return "banklogo3.png,建设银行储蓄卡,5,5,富友-建行"; //单笔限额，单日限额
    } else if (channelid == "7104") {
        return "banklogo4.png,中国银行储蓄卡,5,50,富友-中行"; //单笔限额，单日限额
    } else if (channelid == "7105") {
        return "banklogo5.png,平安银行储蓄卡,5,5,富友-平安银行"; //单笔限额，单日限额
    } else if (channelid == "7106") {
        return "banklogo7.png,兴业银行储蓄卡,5,5,富友-兴业银行"; //单笔限额，单日限额
    } else if (channelid == "7107") {
        return "banklogo8.png,浦发银行储蓄卡,10,100,富友-浦发银行"; //单笔限额，单日限额
    } else if (channelid == "7108") {
        return "banklogo6.png,交通银行储蓄卡,5,20,富友-交行"; //单笔限额，单日限额
    } else if (channelid == "7109") {
        return "banklogo9.png,邮政银行储蓄卡,50,100,富友-邮储"; //单笔限额，单日限额
    } else if (channelid == "7110") {
        return "banklogo10.png,中信银行储蓄卡,1,2,富友-中信银行"; //单笔限额，单日限额
    } else if (channelid == "7111") {
        return "banklogo11.png,光大银行储蓄卡,5,5,富友-光大银行"; //单笔限额，单日限额
    } else if (channelid == "7113") {
        return "banklogo12.png,广发银行储蓄卡,50,100,富友-广发"; //单笔限额，单日限额
    } else if (channelid == "7112") {
        return "banklogo13.png,招商银行储蓄卡,10,10,富友-招行"; //单笔限额，单日限额
    }
}
// 银行名称
function getBankName (channelid) {
    var bank = "";
    if (channelid == 7201) {
        bank = "汇付-工商银行";
    } else if (channelid == 7202) {
        bank = "汇付-农业银行";
    } else if (channelid == 7203) {
        bank = "汇付-中国银行";
    } else if (channelid == 7204) {
        bank = "汇付-建设银行";
    } else if (channelid == 7205) {
        bank = "汇付-交通银行";
    } else if (channelid == 7206) {
        bank = "汇付-中信银行";
    } else if (channelid == 7207) {
        bank = "汇付-光大银行";
    } else if (channelid == 7208) {
        bank = "汇付-华夏银行";
    } else if (channelid == 7209) {
        bank = "汇付-民生银行";
    } else if (channelid == 7210) {
        bank = "汇付-广发银行";
    } else if (channelid == 7211) {
        bank = "汇付-招商银行";
    } else if (channelid == 7212) {
        bank = "汇付-兴业银行";
    } else if (channelid == 7213) {
        bank = "汇付-浦发银行";
    } else if (channelid == 7214) {
        bank = "汇付-平安银行";
    } else if (channelid == 7215) {
        bank = "汇付-浙商银行";
    } else if (channelid == 7216) {
        bank = "汇付-邮储银行";
    } else if (channelid == 7217) {
        bank = "汇付-上海银行";
    } else if (channelid == 7218) {
        bank = "汇付-渤海银行";
    } else if (channelid == 7101) {//富友
        bank = "富友-工商银行";
    } else if (channelid == 7102) {
        bank = "富友-农业银行";
    } else if (channelid == 7103) {
        bank = "富友-建设银行";
    } else if (channelid == 7104) {
        bank = "富友-中国银行";
    } else if (channelid == 7105) {
        bank = "富友-平安银行";
    } else if (channelid == 7106) {
        bank = "富友-兴业银行";
    } else if (channelid == 7107) {
        bank = "富友-浦发银行";
    } else if (channelid == 7108) {
        bank = "富友-交通银行";
    } else if (channelid == 7109) {
        bank = "富友-邮储银行";
    } else if (channelid == 7110) {
        bank = "富友-中信银行";
    } else if (channelid == 7111) {
        bank = "富友-光大银行";
    } else if (channelid == 7112) {
        bank = "富友-招商银行";
    } else if (channelid == 7113) {
        bank = "富友-广发银行";
    }
    return bank;
}
// 银行筛选
function getBankInfo (channelid) {
    var bank = "";
    if (channelid == "0103" || channelid == "7002" || channelid == "7102" || channelid == "8403" || channelid == "9005" || channelid == "7202") {
        bank = '农业银行';
    } else if (channelid == "0104" || channelid == "7004" || channelid == "7104" || channelid == "8404" || channelid == "9011" || channelid == "7203") {
        bank = '中国银行';
    } else if (channelid == "0105" || channelid == "7003" || channelid == "7103" || channelid == "8402" || channelid == "9012" || channelid == "7204") {
        bank = '建设银行';
    } else if (channelid == "0120" || channelid == "7001" || channelid == "7101" || channelid == "8406" || channelid == "8882" || channelid == "9004" || channelid == "7201") {
        bank = '工商银行';
    } else if (channelid == "0301" || channelid == "1301" || channelid == "7008" || channelid == "7108" || channelid == "8410" || channelid == "9009" || channelid == "7205") {
        bank = '交通银行';
    } else if (channelid == "0303" || channelid == "1303" || channelid == "7011" || channelid == "7111" || channelid == "8401" || channelid == "9001" || channelid == "7207") {
        bank = '光大银行';
    } else if (channelid == "0307") {
        bank = '深圳发展银行';
    } else if (channelid == "0308" || channelid == "7012" || channelid == "7112" || channelid == "7211") {
        bank = '招商银行';
    } else if (channelid == "0309" || channelid == "7006" || channelid == "7106" || channelid == "8409" || channelid == "9017" || channelid == "7212") {
        bank = '兴业银行';
    } else if (channelid == "0310" || channelid == "1310" || channelid == "7007" || channelid == "7107" || channelid == "9003" || channelid == "7213") {
        bank = '浦发银行';
    } else if (channelid == "0311" || channelid == "1311" || channelid == "7109" || channelid == "9007" || channelid == "7216") {
        bank = '邮储银行';
    } else if (channelid == "0410" || channelid == "7005" || channelid == "7105" || channelid == "8408" || channelid == "9002" || channelid == "7214") {
        bank = '平安银行';
    } else if (channelid == "1318" || channelid == "7010" || channelid == "7110" || channelid == "8411" || channelid == "7206") {
        bank = '中信银行';
    } else if (channelid == "1403") {
        bank = '北京银行';
    } else if (channelid == "7009" || channelid == "7114" || channelid == "7208") {
        bank = '华夏银行';
    } else if (channelid == "7113" || channelid == "9016" || channelid == "7210") {
        bank = '广发银行';
    } else if (channelid == "7115" || channelid == "8866" || channelid == "9010" || channelid == "7209") {
        bank = '民生银行';
    } else if (channelid == "8405" || channelid == "9008") {
        bank = '温州银行';
    } else if (channelid == "9006" || channelid == "7217") {
        bank = '上海银行';
    } else if (channelid == "9013") {
        bank = '大连银行';
    } else if (channelid == "9014") {
        bank = '汉口银行';
    } else if (channelid == "9015") {
        bank = '重庆银行';
    } else if (channelid == "7215") {
        bank = '浙商银行';
    } else if (channelid == "7218") {
        bank = '渤海银行';
    }
    return bank;
}

//组合名称
function getCombinationNameByCode (combinationcode) {
    var fxdjDesc;
    if (combinationcode == "ZH0004") {
        fxdjDesc = "目标风险-风险等级1";
    } else if (combinationcode == "ZH0005") {
        fxdjDesc = "目标风险-风险等级2";
    } else if (combinationcode == "ZH0006") {
        fxdjDesc = "目标风险-风险等级3";
    } else if (combinationcode == "ZH0007") {
        fxdjDesc = "目标风险-风险等级4";
    } else if (combinationcode == "ZH0008") {
        fxdjDesc = "目标风险-风险等级5";
    } else if (combinationcode == "ZH0009") {
        fxdjDesc = "目标风险-风险等级6";
    } else if (combinationcode == "ZH0010") {
        fxdjDesc = "目标风险-风险等级7";
    } else if (combinationcode == "ZH0011") {
        fxdjDesc = "目标风险-风险等级8";
    } else if (combinationcode == "ZH0012") {
        fxdjDesc = "目标风险-风险等级9";
    } else if (combinationcode == "ZH0013") {
        fxdjDesc = "目标风险-风险等级10";
    } else if (combinationcode == "ZH0020") {
        fxdjDesc = "目标收益-买车购房";
    } else if (combinationcode == "ZH0021") {
        fxdjDesc = "目标收益-子女教育";
    } else if (combinationcode == "ZH0022") {
        fxdjDesc = "目标收益-养老储蓄";
    } else if (combinationcode == "ZH0032") {
        fxdjDesc = "目标标的-热点主题";
    } else if (combinationcode == "ZH0033") {
        fxdjDesc = "目标标的-优选资产";
    } else if (combinationcode == "ZHZ000") {
        fxdjDesc = "盆满钵盈(进取型)";
    } else if (combinationcode == "ZHZ001") {
        fxdjDesc = "安心养老(保守型)";
    } else if (combinationcode == "ZHZ002") {
        fxdjDesc = "步步稳盈(稳健型)";
    } else if (combinationcode == "ZHZ003") {
        fxdjDesc = "薪满益足(平衡型)";
    } else if (combinationcode == "ZH0034") {
        fxdjDesc = "节节高升(成长型)";
    } else if (combinationcode == "ZH0014") { //精准理财
        fxdjDesc = "精准理财-C1(保守型)";
    } else if (combinationcode == "ZH0015") {
        fxdjDesc = "精准理财-C2(稳健型)";
    } else if (combinationcode == "ZH0016") {
        fxdjDesc = "精准理财-C3(平衡型)";
    } else if (combinationcode == "ZH0017") {
        fxdjDesc = "精准理财-C4(成长型)";
    } else if (combinationcode == "ZH0018") {
        fxdjDesc = "精准理财-C5(进取型)";
    } else {
        fxdjDesc = combinationcode;
    }
    return fxdjDesc;
}


//金额大写
function amountWords (num, id) {
    if (RMB(num) != false && Number(num) > 0) {
        if (RMB(num).toString().indexOf("2") > 0) {
            document.getElementById(id).innerHTML = RMB(num);
            document.getElementById(id).style.color = '#FF3300';
        } else {
            document.getElementById(id).innerHTML = RMB(num) + '(元)';
            document.getElementById(id).style.color = '#FF3300';
        }
    } else {
        document.getElementById(id).innerHTML = '';
        document.getElementById(id).style.color = 'red';
    }
}
// 份额大写
function applicationamountinfo (num, id) {

    if (RMB(num) != false && Number(num) > 0) {
        document.getElementById(id).innerHTML = RMB(num) + '(份)';
        document.getElementById(id).style.color = '#FF3300';
    } else {
        document.getElementById(id).innerHTML = '';
        document.getElementById(id).style.color = 'red';
    }
}

// 字符长度
function LengthB (str) {
    var p1 = new RegExp('%u..', 'g')
    var p2 = new RegExp('%.', 'g')
    return escape(str).replace(p1, '').replace(p2, '').length
}

function RMB (requestshare) {
    var low // float
    var i, k, j, l_xx1;
    // int
    var cap = "",
        dxnr, xx1, unit, lastDigit = "",
        endUnit = "",
        lastUnit = "";
    // string
    var a = ("" + requestshare).replace(/(^0*)/g, "").split(".");

    var digits = "零壹贰叁肆伍陆柒捌玖";
    var units = "份 点拾佰仟万拾佰仟亿拾佰仟";
    var digit;
    low = parseFloat(requestshare);
    if (isNaN(low))
        return "";

    xx1 = Math.round(low * 100.0) + "";
    l_xx1 = xx1.length;

    // if (l_xx1 > 13) {
    // return "必须小于5,000,000,000,000.00";
    // }
    //
    for (i = 0; i < l_xx1; i++) {
        j = l_xx1 - 1 - i;
        unit = units.substr(j, 1);
        // 生成大写单位，即'..份拾...'
        k = parseInt(xx1.substr(i, 1));
        digit = digits.substr(k, 1);
        // 生成大写数字, 即'零壹贰叁...'
        cap = cap + digit + unit;
    }

    cap = cap.replace(" ", "");
    cap = cap.replace(/零拾|零佰|零仟/g, "零");
    cap = cap.replace(/零+/g, "零");
    cap = cap.replace(/零亿/g, "亿");
    cap = cap.replace(/零万/g, "万");
    cap = cap.replace(/零点/g, "点");
    cap = cap.replace(/零份/g, "份");
    cap = cap.replace(/亿万/g, "亿");
    cap = cap.replace(/^壹拾/, "拾");
    cap = cap.replace(/点份$/, "份整");
    cap = cap.replace(/份整$/, "");
    cap = cap.replace(/零$/, "");
    cap = cap.replace(/份$/, "");
    if (a.length > 1 && LengthB(a[1]) > 2)
        cap = '小数点位数不应超过2位';
    if (a.length > 1 && LengthB(a[0]) == 0 && a[1].charAt(0) != '0')
        cap = cap.replace("", "零点");
    if (a.length > 1 && LengthB(a[0]) == 0 && a[1].charAt(0) == '0')
        cap = cap.replace("", "零点零");
    return cap;
}

// 获取cookie
function getCookie (key) {
    if (document.cookie.length > 0) {
        var start = document.cookie.indexOf(key + "=");
        if (start !== -1) {
            start = start + key.length + 1;
            var end = document.cookie.indexOf(";", start);
            if (end === -1) end = document.cookie.length;
            return unescape(document.cookie.substring(start, end));
        }
    }
    return "";
}
// 保存cookie
function setCookie (cName, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = cName + "=" + decodeURIComponent(value) + (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
}

function encrypt (source, fkey) {
    var target = "";
    var ch;
    if (fkey.length == 0) {
        return source;
    } else {
        for (var i = 0, j = 0; i < source.length; i++, j++) {
            if (j > fkey.length - 1) {
                j = j % fkey.length;
            }
            ch = source.charCodeAt(i) + fkey.charCodeAt(j);
            if (ch > 65535) {
                ch = ch % 65535; // ch - 33 = (ch - 33) % 95 ;
            }
            target += String.fromCharCode(ch);
        }
    }

    return target;
}
var passKey = '4c05c54d952b11e691d76c0b843ea7f9';
// 展恒基金cookie
function setDomainCookie (c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/" + ";domain=myfund.com";
}

//清除cookie  
function delCookie (name) {
    setCookie(name, "", -1);
}

function logout () {
    window.sessionStorage.clear()
    delCookie('acticePath', '', -1)
    delCookie('sessionid', '', -1)
    delCookie('u_phone1', '', -1)
    delCookie('u_name1', '', -1)
    delCookie('u_id', '', -1)
    delCookie('Password', '', -1)
    delCookie('u_custno1', '', -1)
    setDomainCookie('u_name', '', -1)
    setDomainCookie('dct_Member', '', -1)
    setDomainCookie('u_risk', '', -1)
    setDomainCookie('u_custno', '', -1)
    setDomainCookie('u_phone', '', -1)
    // this.$router.push({ name: 'login' })
}

function tradeStatus (fundCode) {
    var resData = '';
    this.$http.get('https://www.myfund.com/webinterface/Bamboo.ashx?command=getFundStatus&fundCode=' + fundCode).then(res => {
        // console.log(res);
        resData = res.data.Code; //1可购买，其它不可购买
    })

    return resData;
}



// 购买风险提示
function lm_checkFundLevel_jz (code, buytype) {
    if (code.length == 6) {
        var level = getjzfxdjBycode(code);
    } else {
        var level = code;
    }
    var flstr = "低风险";
    if (level == "02") {
        flstr = "中低风险";
    } else if (level == "03") {
        flstr = "中风险";
    } else if (level == "04") {
        flstr = "中高风险";
    } else if (level == "05") {
        flstr = "高风险";
    }
    var ulstr = "保守型";
    if (getCookie('u_risk') == "02") {
        ulstr = "稳健型";
    } else if (getCookie('u_risk') == "03") {
        ulstr = "平衡型";
    } else if (getCookie('u_risk') == "04") {
        ulstr = "成长型";
    } else if (getCookie('u_risk') == "05") {
        ulstr = "进取型";
    }
    if (level > getCookie('u_risk') && getCookie('u_risk') == "01") {
        return false
    }
    if (level > getCookie('u_risk')) {
        return false
    }
    // if (top.riskInfo.lookUp('evaluateflag') == glbConst.PAGE_YES &&
    //     level > getCookie('u_risk') && getCookie('u_risk') == "01") {
    //     var msg = '尊敬的投资者，抱歉，该基金风险等级为“' + flstr + '”，您是保守型投资者，只能定投风险等级为“低风险”的产品';
    //     getBuyUrlAfterTest("groupbuybuy", code, buytype);
    //     showMasklm(msg, "退出", "重新测评", "lm_closeMask1()", "doRiskTest()");
    //     return false;
    // }
    // if (top.riskInfo.lookUp('evaluateflag') == glbConst.PAGE_YES &&
    //     level > getCookie('u_risk')) {
    //     var msg = '尊敬的投资者，该基金风险等级为“' + flstr + '”，超出了您“' + ulstr + '”风险承受能力。购买后可能面临“' + flstr + '”基金业绩波动风险，您确定购买吗？';
    //     if (buytype == "0") {
    //         showMasklm(msg, "取消", "继续购买", "lm_closeMask()", "jingzhunNext()");
    //         return false;
    //     } else {
    //         showMasklm(msg, "取消", "继续购买", "lm_closeMask()", "jingzhun1Next()");
    //         return false;
    //     }
    // }
    return true;
}

// 组合风险等级
function getjzfxdjBycode (code) {
    if (code == "ZH0004") {
        return "01";
    } else if (code == "ZH0005") {
        return "01";
    } else if (code == "ZH0006") {
        return "02";
    } else if (code == "ZH0007") {
        return "02";
    } else if (code == "ZH0008") {
        return "02";
    } else if (code == "ZH0009") {
        return "03";
    } else if (code == "ZH0010") {
        return "03";
    } else if (code == "ZH0011") {
        return "03";
    } else if (code == "ZH0012") {
        return "04";
    } else if (code == "ZH0013") {
        return "04";
    } else if (code == "ZH0020") {
        return "04";
    } else if (code == "ZH0021") {
        return "03";
    } else if (code == "ZH0022") {
        return "01";
    } else if (code == "ZH0032") {
        return "05";
    } else if (code == "ZH0033") {
        return "04";
    } else if (code == "ZH0034") { //成长型
        return "04";
    } else if (code == "ZHZ000") {
        return "05";
    } else if (code == "ZHZ001") {
        return "01";
    } else if (code == "ZHZ002") {
        return "02";
    } else if (code == "ZHZ003") {
        return "03";
    }
}

// 组合,基金风险等级汉
function getcomLevel (code) {
    if (code == "ZHZ001" || code == "01") {
        return "低风险";
    } else if (code == "ZHZ002" || code == "02") {
        return "中低风险";
    } else if (code == "ZHZ003" || code == "03") {
        return "中风险";
    } else if (code == "ZH0034" || code == "04") {
        return "中高风险";
    } else if (code == "ZHZ000" || code == "05") {
        return "高风险";
    }
}
// 基金风险等级汉
function getfundLevel (code) {
    if (code == "01") {
        return "低风险";
    } else if (code == "02") {
        return "低风险、中低风险";
    } else if (code == "03") {
        return "中低风险、中风险";
    } else if (code == "04") {
        return "中风险、中高风险";
    } else if (code == "05") {
        return "中高风险、高风险";
    }
}

function getPersonalLevel (code) {
    if (code == "01" || code == "0") {
        return "极端保守型"
    } else if (code == "02") {
        return "相对稳健型"
    } else if (code == "03") {
        return "稳健平衡型"
    } else if (code == "04") {
        return "相对成长型"
    } else if (code == "05") {
        return "积极进取型"
    }
}

function getFundType (code) {
    if (code == "01") {
        return "货币型、保本型"
    } else if (code == "02") {
        return "债券型、混合型"
    } else if (code == "03") {
        return "债券型、混合型、股票型"
    } else if (code == "04") {
        return "混合型、股票型"
    } else if (code == "05") {
        return "混合型、股票型"
    }
}

// 组合费率
function getrate (combinationcode) {
    var rank;
    if (combinationcode == "ZHZ000" || combinationcode == "ZH0018") {
        rank = "5";
    } else if (combinationcode == "ZHZ001" || combinationcode == "ZH0014") {
        rank = "1";
    } else if (combinationcode == "ZHZ002" || combinationcode == "ZH0015") {
        rank = "2";
    } else if (combinationcode == "ZHZ003" || combinationcode == "ZH0016") {
        rank = "3";
    } else if (combinationcode == "ZH0034" || combinationcode == "ZH0017") {
        rank = "4";
    }
    return rank
}
// 组合
function getCom (type) {
    var rank;
    if (type == "1") {
        rank = "ZHZ001";
    } else if (type == "2") {
        rank = "ZHZ002";
    } else if (type == "3") {
        rank = "ZHZ003";
    } else if (type == "4") {
        rank = "ZH0034";
    } else if (type == "5") {
        rank = "ZHZ000";
    }
    return rank
}
// 智能组合
function getSmart (type) {
    var rank;
    if (type == "1") {
        rank = "ZH0014";
    } else if (type == "2") {
        rank = "ZH0015";
    } else if (type == "3") {
        rank = "ZH0016";
    } else if (type == "4") {
        rank = "ZH0017";
    } else if (type == "5") {
        rank = "ZH0018";
    }
    return rank
}
// 智能组合名称
function getSmartName (type) {
    var name;
    if (type == "1") {
        name = "精准理财-C1(保守型)";
    } else if (type == "2") {
        name = "精准理财-C2(稳健型)";
    } else if (type == "3") {
        name = "精准理财-C3(平衡型)";
    } else if (type == "4") {
        name = "精准理财-C4(成长型)";
    } else if (type == "5") {
        name = "精准理财-C5(进取型)";
    }
    return name
}

// 定投费率
function ForDight (Dight, How) {
    Dight = (Dight * Math.pow(10, How) / Math.pow(10, How)).toFixed(How);
    Dight = Dight * 1;
    return Dight;
}

// 外部跳转
function getSession (business) {
    if (business == '022') {
        return 'publicBuy'
    } else if (business == '039') {
        return 'fixedBuyOpen'
    } else if (business == '023') {
        return 'combinationSmartBuy'
    } else if (business == '021') {
        return 'combinationBuy'
    } else if (business == '063') {
        return 'accountManagement'
    } else if (business == '024') {
        return 'fundDiagnosisPay'
    }

}
// 定投时间描述
function TimeDescription (each, day) {
    if (each == "0") { //月
        return '每月' + day + '号'
    } else if (each == "1") { //周
        return '每周星期' + timeStr(day)
    } else if (each == "2") { //双周
        return '每双周星期' + timeStr(day)
    } else if (each == "4") { //每天
        return '每日'
    }
}

function timeStr (day) {
    if (day == "1" || day == "01") {
        return '一'
    } else if (day == "2" || day == "02") {
        return '二'
    } else if (day == "3" || day == "03") {
        return '三'
    } else if (day == "4" || day == "04") {
        return '四'
    } else if (day == "5" || day == "05") {
        return '五'
    }
}
// 定投时间 20210510
function timeConversion (each, time) {

    if (each == "0") { //月
        return '每月' + day + '号'
    } else if (each == "1") { //周
        return '每周星期' + day
    } else if (each == "2") { //双周
        return '每双周星期' + day
    } else if (each == "4") { //每天
        return '每[1]天'
    }
}
// 定投修改时间
function GetLatestDate (thisDate, type, day) {
    day = day - 0;
    switch (type) {
        case "0":
            thisDate = GetMonthDate(new Date(), day);
            break;
        case "1":
            thisDate = GetWeekDate(new Date(), day);
            break;
        case "2":
            thisDate = GetWeekDate(new Date(), day);
            break;
        case "4":
            thisDate = GetDayDate(new Date(), day);
            break;
    }
    return FormatDate(thisDate);
}

function GetMonthDate (thisDate, day) {
    thisDate.setDate(thisDate.getHours() >= 15 ? thisDate.getDate() + 1 : thisDate.getDate());
    thisDate = thisDate.getDate() >= day ? thisDate.setMonth(thisDate.getMonth() + 1) : thisDate;
    return new Date(thisDate).setDate(day);
}

function GetWeekDate (thisDate, day) {
    thisDate.setDate(thisDate.getHours() >= 15 ? thisDate.getDate() + 1 : thisDate.getDate());
    var num = day > thisDate.getDay() ? day - thisDate.getDay() : day - thisDate.getDay() + 7;
    return thisDate.setDate(thisDate.getDate() + num);
}

function GetDayDate (thisDate, day) {
    day = thisDate.getHours() >= 15 ? thisDate.getDate() + 2 : thisDate.getDate() + 1;
    return new Date(thisDate).setDate(day);
}

function FormatDate (date) {
    var date = new Date(date);
    var YY = date.getFullYear();
    var MM = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return YY + '' + MM + '' + DD;
}

//根据身份证获取性别
function getSex (IdCard) {
    var sexNo = "";
    var sex = "";
    if (IdCard.length === 15) {
        sexNo = IdCard.substring(14, 15)
    } else if (IdCard.length === 18) {
        sexNo = IdCard.substring(16, 17)
    }
    if (sexNo % 2 == 0) {
        sex = '女';
    } else {
        sex = '男';
    }
    return sex;
}
//根据身份证获取生日
function getBirthday (IdCard) {
    var birthday = "";
    if (IdCard.length === 15) {
        birthday = '19' + IdCard.substr(6, 2) + '-' + IdCard.substr(8, 2) + '-' + IdCard.substr(10, 2);
    } else if (IdCard.length === 18) {
        birthday = IdCard.substr(6, 4) + '-' + IdCard.substr(10, 2) + '-' + IdCard.substr(12, 2);
    }
    return birthday;
}

// 积分兑换
function couponExchange (code) {
    var integral;
    if (code == "15005566185192142992161389954465") { //满减券
        integral = "500";
    } else if (code == "15005566185192142992161389954466") {
        integral = "1000";
    } else if (code == "15005566185192142992161389954477") {
        integral = "2000";
    } else if (code == "15005565271195634289814020399000") { //立减
        integral = "2000";
    } else if (code == "15005565881935425630120197655637") {
        integral = "5000";
    } else if (code == "15005566185192142992161389954422") {
        integral = "10000";
    } else if (code == "15005566185192142992161389954455") {
        integral = "20000";
    } else if (code == "15005566263192142992161389954433") { //点财通
        integral = "19900";
    } else if (code == "15005566285192142992161389954456") {
        integral = "19900";
    }
    return integral
}

// 文件转base64格式
function getBase64 (file) {
    return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
            imgResult = reader.result;
        };
        reader.onerror = function (error) {
            reject(error);
        };
        reader.onloadend = function () {
            resolve(imgResult);
        };
    });
}
// 密码内不能含有3个连续相同的字符
function checkSeries (inputpass) {
    for (var i = 0; i < inputpass.length; i++) {
        var charpwd1 = inputpass.charCodeAt(i);
        var charpwd2 = inputpass.charCodeAt(i + 1);
        var charpwd3 = inputpass.charCodeAt(i + 2);
        if ((charpwd2 == (charpwd1 + 1) && charpwd3 == (charpwd2 + 1)) ||
            (charpwd2 == (charpwd1 - 1) && charpwd3 == (charpwd2 - 1))) {
            return false;
        }
    }
    return true;
}

// 补0（001）(3, "0", item.AdviserCode)
function dataLeftCompleting (bits, identifier, value) {
    value = Array(bits + 1).join(identifier) + value;
    return value.slice(-bits);
};

// XML格式
function getJsonByXml (res) {
    var data = res.slice(res.indexOf('<return>') + 8);
    data = data.slice(0, data.indexOf('</return>'));
    data = JSON.parse(data);
    return data;
};

// 消息推送  类型  日期  基金名称 金额  定投日期  转换基金名称
function getContext (type, date, fundname, money, dtDate, fundname2) {
    var context = "";
    switch (type) {
        case 1://银行卡申购 √
            context = "尊敬的客户，您于" + date + "办理的“" + fundname + "”申购业务已受理，申购金额" + money + "元。";
            break;
        case 2://银行卡申购撤单 √
            context = "尊敬的客户，您于" + date + "办理的“" + fundname + "”申购业务撤单成功，原申购金额" + money + "元将于T+1日到账，请注意查看。（注：汇款订单未支付不退款）";
            break;
        case 3://赎回到银行卡 √
            context = "尊敬的客户，您于" + date + "办理的“" + fundname + "”赎回业务已受理，赎回份额" + money + "份。";
            break;
        case 4://赎回到银行卡撤单 √
            context = "尊敬的客户，您于" + date + "办理的“" + fundname + "”赎回" + money + "份业务已撤单。";
            break;
        case 5://恒宝宝申购基金 √
            context = "尊敬的客户，您于" + date + "办理的恒宝宝申购“" + fundname + "”业务已受理，申购金额" + money + "元。";
            break;
        case 6://恒宝宝申购基金撤单 √
            context = "尊敬的客户，您于" + date + "办理的恒宝宝申购“" + fundname + "”，申购金额" + money + "元业务已撤单。";
            break;
        case 7://基金赎回到恒宝宝 √
            context = "尊敬的客户，您于" + date + "办理的“" + fundname + "”赎回至恒宝宝业务已受理，赎回份额" + money + "份。";
            break;
        case 8://基金赎回到恒宝宝撤单 √
            context = "尊敬的客户，您于" + date + "办理的“" + fundname + "”赎回至恒宝宝，赎回份额" + money + "份业务已撤单。";
            break;
        case 9://定投开通 √
            context = "尊敬的客户，您于" + date + "办理的“" + fundname + "”定投业务已开通，定投时间为" + dtDate + "，定投金额为" + money + "元。请注意银行卡可用金额的变动，确保定投计划正常进行。";
            break;
        case 10://定投修改
            context = "尊敬的客户，您办理的“" + fundname + "”定投业务计划已修改，定投时间改为" + dtDate + "，定投金额改为" + money + "元。请注意银行卡可用金额的变动，确保定投计划正常进行。";
            break;
        case 11://定投终止 √
            context = "尊敬的客户，您办理的“" + fundname + "”定投计划已终止。";
            break;
        case 18://定投暂停 √
            context = "尊敬的客户，您办理的“" + fundname + "”定投计划已暂停。";
            break;
        case 19://定投恢复 √
            context = "尊敬的客户，您办理的“" + fundname + "”定投计划已恢复。";
            break;
        case 12://基金转换 √
            context = "尊敬的客户，您于" + date + "办理的" + "“" + fundname + "”转换“" + fundname2 + "”业务已受理，申请份额 " + money + "份。";
            break;
        case 13://基金转换撤单 √
            context = "尊敬的客户，您于" + date + "办理的“" + fundname + "”转换“" + fundname2 + "”业务已撤单。";
            break;
        case 14://恒宝宝充值
            context = "尊敬的客户，您于" + date + "办理的恒宝宝充值业务已受理，申购金额" + money + "元。";
            break;
        case 15://恒宝宝充值撤单
            context = "尊敬的客户，您于" + date + "办理的恒宝宝充值业务撤单成功，原申购金额" + money + "元将于T+1日到账，请注意查看。（注：汇款订单未支付不退款）";
            break;
        case 16://恒宝宝提现
            context = "尊敬的客户，您于" + date + "办理的恒宝宝提现业务已受理，赎回份额" + money + "份。";
            break;
        case 17://恒宝宝提现撤单
            context = "尊敬的客户，您于" + date + "办理的恒宝宝提现" + money + "份业务已撤单。";
            break;
        case 20://恒宝宝基金汇款
            context = "尊敬的客户，您于" + date + "办理的“" + fundname + "”汇款申购已下单， 申购金额" + money + "元，请尽快完成汇款，您可从【基金资产】-【交易记录】查看汇款信息和交易说明。";
            break;
        case 21://组合(PC还未弄汇款)
            context = "尊敬的客户，您于" + date + "办理的“" + fundname + "”汇款申购已下单， 申购金额" + money + "元，您可从【基金组合】-【交易记录】查看汇款信息和交易说明。";
            break;
        case 22://组合
            context = "尊敬的客户，您于" + date + "办理的" + fundname + "，赎回至银行卡业务已受理。";
            break;
        case 23://组合(资产的撤单 combinationAssetsMessage 需要重新写并测试)
            context = "尊敬的客户，您于" + date + "办理的" + fundname + "申购业务已撤单。原申购金额" + money + "元将于T+1个工作日到账，请注意查收。（注：汇款订单未支付不退款）";
            break;
    }
    return context;
};

// 绑卡或支付时银行应答码
function getPayMessage (code) {
    let message = "";
    if (code == "P01") {//（包含未知错误码）
        message = "交易失败";
    } else if (code == "P02") {
        message = "系统未开放或暂时关闭，请稍后再试";
    } else if (code == "P06") {
        message = "交易失败，详情查看银行返回信息";
    } else if (code == "P07") {
        message = "验卡失败，具体问题参见对应银行认证失败原因";
    } else if (code == "P12") {
        message = "重复交易，交易发送太过密集，上一笔交易在银行端尚未完成";
    } else if (code == "P21") {
        message = "持卡人信息有误";
    } else if (code == "P22") {
        message = "持卡人系统错误";
    } else if (code == "P24") {
        message = "卡信息有误";
    } else if (code == "P25") {
        message = "卡系统错误";
    } else if (code == "P26") {
        message = "卡系统错误";
    } else if (code == "P33") {
        message = "金额超限";
    } else if (code == "P35") {
        message = "网关不支持签约交易";
    } else if (code == "P36") {
        message = "与原交易信息不符";
    } else if (code == "P37") {
        message = "已超过最大查询次数或操作过于频繁";
    } else if (code == "P38") {
        message = "风险受限";
    } else if (code == "P42") {
        message = "扣款成功但交易超过规定支付时间";
    } else if (code == "P49") {
        message = "无签约记录";
    } else if (code == "P50") {
        message = "账户错误或冻结";
    } else if (code == "P51") {
        message = "交易金额低于下限";
    } else if (code == "P52") {
        message = "交易失败，未在我方进行实名认证或认证不通过";
    } else if (code == "P57") {
        message = "银行卡类型不支持";
    } else if (code == "P58") {
        message = "认证失败";
    } else if (code == "P59") {
        message = "非法交易次数超限";
    } else if (code == "P60") {
        message = "交易失败，请联系发卡银行";
    } else if (code == "P61") {
        message = "您所输入的银行卡号有误或卡号已经无效";
    } else if (code == "P62") {
        message = "交易失败，发卡银行不支持该商户，请更换其他银行卡";
    } else if (code == "P63") {
        message = "卡状态不正确";
    } else if (code == "P64") {
        message = "银行卡余额不足";
    } else if (code == "P65") {
        message = "持卡人身份信息，手机号或 CVN2 输入不正确，验证失败";
    } else if (code == "P66") {
        message = "持卡人身份信息或手机号输入不正确，验证失败";
    } else if (code == "P67") {
        message = "密码输入次数超限";
    } else if (code == "P68") {
        message = "您的银行卡暂不支持该业务";
    } else if (code == "P69") {
        message = "卡状态异常，或银行卡额度受限，请确认银行卡支付限额";
    } else if (code == "P71") {
        message = "对不起，你所输的验证码有误，请核实后再试！";
    } else if (code == "P72") {
        message = "银行卡未开通认证支付";
    } else if (code == "P73") {
        message = "对不起，您所输的户名有误，请核实后再试！";
    } else if (code == "P74") {
        message = "对不起，您的证件类型有误，请核实后再试！";
    } else if (code == "P75") {
        message = "对不起，您的所输证件号码有误，请核实后再试！";
    } else if (code == "P76") {
        message = "对不起，您所输的手机号码有误，请核实后再试！";
    } else if (code == "P77") {
        message = "验证码发送失败";
    } else if (code == "P79") {
        message = "对不起，您的用户信息未通过银行验证，请核实后再试！";
    } else if (code == "P80") {
        message = "银行卡状态异常";
    } else if (code == "P81") {
        message = "支付失败，请稍后再试";
    } else if (code == "P83") {
        message = "余额不足次数超限，请隔日再试";
    } else if (code == "P84") {
        message = "单笔金额超限";
    } else if (code == "P85") {
        message = "单日金额超限";
    } else if (code == "P86") {
        message = "单月金额超限";
    } else if (code == "P88") {
        message = "支付订单信息有误";
    } else if (code == "P91") {
        message = "系统异常";
    } else if (code == "P94") {
        message = "系统错误";
    } else if (code == "PA0") {
        message = "未知错误";
    } else if (code == "PA1") {
        message = "风控拦截";
    } else if (code == "PB0") {
        message = "无可用支付方式";
    } else if (code == "PB1") {
        message = "消费超过该商户支持限额";
    } else if (code == "PF0") {
        message = "支付渠道问题（渠道关闭、维护或不支持）";
    } else if (code == "PF1") {
        message = "交易失败，客户未签约或未开通认证支付";
    } else if (code == "PF2") {
        message = "交易失败，未添加白名单";
    } else if (code == "PF3") {
        message = "验卡失败，请稍后再试";
    } else if (code == "PF4") {
        message = "该卡当日失败次数超过阀值";
    } else if (code == "PF6") {
        message = "此用户需要重新签约";
    } else if (code == "PS2") {
        message = "需跳转页面签约";
    } else if (code == "PU0") {
        message = "银行无签约信息，或已解约";
    } else if (code == "PU1") {
        message = "汇付无签约信息，或已解约";
    } else {
        message = "失败";
    }
    return message;
}

export default {
    timeFormat,
    amountFormat,
    getDateStrTh,
    getCurrentDate,
    getDateStrHg,
    getInfobyChannelId,
    amountWords,
    tab,
    getBeforeDate,
    getCookie,
    setCookie,
    delCookie,
    DateDiff,
    logout,
    getCombinationNameByCode,
    getDateStrHz,
    getBankInfo,
    tradeStatus,
    applicationamountinfo,
    lm_checkFundLevel_jz,
    getcomLevel,
    getrate,
    ForDight,
    getSession,
    TimeDescription,
    timeConversion,
    GetLatestDate,
    setDomainCookie,
    getSmart,
    getSmartName,
    getSex,
    getBirthday,
    getCom,
    getBankName,
    couponExchange,
    getBase64,
    getfundLevel,
    getPersonalLevel,
    getFundType,
    checkSeries,
    dataLeftCompleting,
    getJsonByXml,
    getContext,
    getPayMessage,
}